import IOption from "common/models/IOption";
import { pick } from "lodash";
import { isEmpty } from "./ArrayUtils";

interface IParamArgs<T = any> {
	params: T;
}

// to make it eaiser to map certain params to a field's args in a typegraph entity
// this is kind of silly
export function filterParams<T>(include: Array<keyof T>, add?: Partial<T>) {
	return (data: IParamArgs<T>) => ({
		params: {...pick(data.params, include), ...add || {} }
	});
}

/**
 * ensure that a value within an enum.
 * useful for param validation.
 * @param allowed - the enum to validate against
 * @param value - the selected value to check
 * @param defaultValue - if not within the enum, the value to return
 */
export function validateEnum<T>(allowed: object, value?: T, defaultValue?: T): T {
	return (value && Object.values(allowed).includes(value)) ? value : defaultValue;
}

/**
 * filter a list of values
 * @param allowed - the enum to validate against
 * @param value - list of values to filter
 * @param defaultValue - what to return if result is empty/falsy
 */
export function validateEnumList<T>(allowed: object, value?: T[], defaultValue?: T[]): T[] | null | undefined {
	if (isEmpty(value)) {
		return defaultValue;
	}
	const allowedList = Object.values(allowed);
	const validValues = value.filter(allowedList.includes);
	return validValues.length > 0 ? validValues : defaultValue;
}

/**
 * ensure that a value is included in a list of valid values
 * @param allowed - list of values allowed
 * @param value - the selected value
 * @param defaultValue - the default value if value is not in allowed list
 */
export function validateList<T = string>(allowed: T[], value?: T, defaultValue?: T): T {
	return (value && allowed.includes(value)) ? value : defaultValue;
}

export function findSelectedOption<T = string>(options: Array<IOption<T>>, value: T): IOption<T> | undefined {
	return value ? options.find((option) => option.value === value) : undefined;
}



// WEBPACK FOOTER //
// ./src/core/util/ParamUtil.ts